<script lang="ts">
	import ClientCard from "@components/ClientCard.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import Carousel from "@components/common/Carousel.svelte";
	import type { EmblaCarouselType } from "embla-carousel";
	import autoscroll from "embla-carousel-auto-scroll";
	import type { ClassValue } from "svelte/elements";
	import type { WebClient } from "@core/schema/WebClient.js";

	const { clients, class: customClass }: { clients: WebClient[]; class?: ClassValue } = $props();
	let api = $state<EmblaCarouselType>();
</script>

<section class={[customClass, "full-width py-8 md:py-16 lg:py-20"]}>
	<HugeHeading level={2} text="stroke[[Naši klienti]]" class="text-center mb-1 sm:mb-4" />
	<div
		role="presentation"
		onmouseleave={(): void => {
			api?.plugins().autoScroll.play();
		}}
	>
		<Carousel
			bind:api
			items={clients}
			options={{ loop: true }}
			plugins={[autoscroll({ playOnInit: true, stopOnMouseEnter: true, startDelay: 0, direction: "backward" })]}
		>
			{#snippet item(client: WebClient)}
				<ClientCard {client} class="mx-1" />
			{/snippet}
		</Carousel>
	</div>
</section>
